import React, { memo } from 'react';
import { MenuItem } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Controller } from 'react-hook-form';
import { AlyceTheme, SelectFilter } from '@alycecom/ui';

import { ShippingAddressField } from '../../../../store/shipping/shipping.types';
import { TState } from '../../../../../../store/countries/countries.types';

import { TFieldProps } from './Fields';

type TRecipientStateSelectProps = TFieldProps & {
  states: TState[];
  label: string;
  onResetErrors: (event: { target: { name: string } }) => void;
};

const useStyles = makeStyles<AlyceTheme>({
  stateSelect: {
    width: '100%',
    marginLeft: 0,
    textAlign: 'left',
  },
});

const RecipientStateSelect = ({
  control,
  error,
  disabled,
  states,
  label,
  onResetErrors,
}: TRecipientStateSelectProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Controller
      control={control}
      name={ShippingAddressField.State}
      render={({ onChange, value }) => (
        <SelectFilter
          dataTestId="ShippingAddressForm.StateSelect"
          classes={{ root: classes.stateSelect }}
          name={ShippingAddressField.State}
          data-private="lipsum"
          label={`${label} *`}
          value={value}
          error={!!error}
          helperText={error}
          disabled={disabled}
          renderItems={() =>
            states.map(item => (
              <MenuItem
                key={item.name}
                value={item.name}
                onClick={() => {
                  onResetErrors({ target: { name: ShippingAddressField.State } });
                  onChange(item.name);
                }}
              >
                {item.name}
              </MenuItem>
            ))
          }
        />
      )}
    />
  );
};

export default memo<TRecipientStateSelectProps>(RecipientStateSelect);
